module.exports = __webpack_public_path__ + "img/xmasParty2.208d5611.jpg";